{
  "EMAIL_TEMPLATE_NOT_FOUND": "Template de email não encontrado",
  "EMAIL_TEMPLATE_DEFAULT_NOT_FOUND": "Não existe conteúdo padrão para \"{{slug}}\"",
  "EMAIL_TEMPLATE_SLUG_TAKEN": "Template com slug \"{{slug}}\" já existe neste idioma",
  "EMAIL_TEMPLATE_LANGUAGE_INVALID": "Idioma do template inválido"
}
